import { render, staticRenderFns } from "./CockpitDespesas.vue?vue&type=template&id=232bfea0&scoped=true"
import script from "./CockpitDespesas.vue?vue&type=script&lang=js"
export * from "./CockpitDespesas.vue?vue&type=script&lang=js"
import style0 from "./CockpitDespesas.vue?vue&type=style&index=0&id=232bfea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232bfea0",
  null
  
)

export default component.exports